export function getUuidFileName(name: string): string {
  return self.crypto.randomUUID() + "." + name.split(".").pop();
}
